import { Injectable } from '@angular/core';
import { PlatformService } from 'lib/platform/index.js';
import { environment } from 'src/app/environments/environment.js';

@Injectable({
	providedIn: 'root'
})
export class StorageService {
	private readonly keyPrefix: string = `${environment.appName}_`;

	constructor(private platformService: PlatformService) {}

	storeValue<T extends string = string>(key: string, value: T): void {
		if (!this.platformService.isBrowser) {
			return;
		}

		localStorage.setItem(this.getFullKey(key), value);
	}

	getValue(key: string): string | undefined {
		if (!this.platformService.isBrowser) {
			return;
		}

		return localStorage.getItem(this.getFullKey(key)) ?? undefined;
	}

	private getFullKey(key: string): string {
		return `${this.keyPrefix}_${key}`;
	}
}
